import { ErrorCode } from '@approvalmax/types';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetWallets, useGetWalletsBalances } from 'shared/data/wallets/v1';
import { getCountryFlagByCountryCode } from 'shared/helpers';
import { getPath, Path } from 'urlBuilder';

import { getCountryCodeByCurrency } from '../../Wallets.helpers';

export const useWallets = (companyId: string) => {
    const { push } = useHistory();
    const { data: walletsList, isLoading: isLoadingGetWallets } = useGetWallets(
        {
            path: { organizationId: companyId },
        },
        {
            onError: (error) => {
                if (error.code === ErrorCode.OrganizationNotFound) {
                    push(getPath(Path.walletsKyc, companyId));
                }
            },
        },
        {
            skipToastForErrorCodes: [ErrorCode.OrganizationNotFound],
        }
    );

    const { data: walletsBalances, isLoading: isLoadingGetWalletsBalances } = useGetWalletsBalances(
        {
            path: { organizationId: companyId },
        },
        {},
        {
            skipToastForErrorCodes: [ErrorCode.OrganizationNotFound],
        }
    );

    const wallets = useMemo(() => {
        return (walletsList?.items ?? []).map((wallet) => {
            const currencyCode = wallet.currency.code;

            const countryCode = getCountryCodeByCurrency(currencyCode);
            const IconFlag = getCountryFlagByCountryCode(countryCode);

            const balance = walletsBalances?.items.find((item) => item.currency === currencyCode);

            return {
                ...wallet,
                balance: balance?.amount || 0,
                IconFlag,
            };
        });
    }, [walletsList, walletsBalances]);

    return {
        wallets,
        isLoadingWallets: isLoadingGetWallets,
        isLoadingWalletsBalances: isLoadingGetWalletsBalances,
    };
};
